import { render, staticRenderFns } from "./AccordionListHtml.vue?vue&type=template&id=32ea346e"
import script from "./AccordionListHtml.vue?vue&type=script&lang=js"
export * from "./AccordionListHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports